
import { defineComponent } from 'vue';

/** Bottom-sheet form used by the lead screens (stage, activity, meeting, transfer, feedback...). */
export default defineComponent({
  name: 'FormSheet',
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, required: true },
    submitLabel: { type: String, default: 'Save' },
    busy: { type: Boolean, default: false },
    danger: { type: Boolean, default: false },
  },
  emits: ['close', 'submit'],
});
